import { render, staticRenderFns } from "./subscribertype.vue?vue&type=template&id=ed5035aa"
import script from "./subscribertype.vue?vue&type=script&lang=js"
export * from "./subscribertype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports